import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Country } from '../../global/interfaces/country';
import { Address } from '../../global/interfaces/address';
import { CountryAndRegions } from '../interfaces/countryWithRegions';
@Injectable({
  providedIn: 'root',
})
export class CountriesService {
  prefix = `${environment.serverUrl}/countries`;
  constructor(private http: HttpClient) {}

  getCountries(onlySupported?: boolean): Promise<Country[]> {
    return this.http.get<Country[]>(`${this.prefix}${onlySupported ? '?onlySupported=true' : ''}`).toPromise();
  }
  getFullAddress(address: Address): Promise<Address> {
    return this.http
      .post<Address>(`${this.prefix}/fullAddress`, { address })
      .toPromise();
  }
  getRegions() {
    return this.http.get<CountryAndRegions[]>(`${this.prefix}/regions`).toPromise();
  }
}
